module.exports = __webpack_public_path__ + "static/media/in.b55580fd.svg";